exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3{\r\n    margin: 0;\r\n    padding-bottom: 13px;\r\n}\r\n.box-header .form-group.tab_sec{margin-bottom: 0;    padding-bottom: 2px;}\r\n.tab_sec .text-danger{    -webkit-transform: translateY(61%);    transform: translateY(61%); margin-left: 10px;}\r\n.custom_style {\r\n    padding-top: 90px;\r\n}\r\n.Reciept_row_two td{background-color: #fff;}\r\n.invoiceList tr td{ vertical-align: middle;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/invoice/invoice.component.css
// module id = ../../../../../src/app/invoice/invoice.component.css
// module chunks = main